import { Utils } from '@ncss/models';
import { FormControlValidator } from '../use-form-control';

export function PhoneNumberValidator(customMsg?: string): FormControlValidator {
  return (val) => {
    if (val && val.length && !Utils.IsValidPhoneNumber(val)) {
      return {
        valid: false,
        errors: [{ msg: customMsg || `Invalid phone number.` }],
      };
    }
    return { valid: true };
  };
}
